// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__4ezq4","iconWithCounter":"styles_iconWithCounter__Xw8qu","counterForLabel":"styles_counterForLabel__Ai0tT","counterForIcon":"styles_counterForIcon__Mi_vZ"};